// extracted by mini-css-extract-plugin
export var dataCell = "_k8-2";
export var dataRow = "_k8-0";
export var headerRow = "_k8-1";